
//various
const DEBUG = true;
const LAZYMODULES = true;

//animations
const ANIMATIONS = true;
const SCROLL = true;
const PARALLAX = true;
const FADEIN = true;
const TRANSITIONS = true;
const TYPOGRAPHY = true;

export {
  DEBUG,
  LAZYMODULES,
  ANIMATIONS,
  SCROLL,
  PARALLAX,
  FADEIN,
  TRANSITIONS,
  TYPOGRAPHY
};
